<template>
    <div class="bannerSale">
        <template v-for="(banner, index) in saleBanners">
            <div v-if="index <= 2" class="bannerSale__item" :key="banner.id" ref="banners" :data-id="banner.id" :data-title="banner.title">
                <a :href="banner.url" class="bannerSale__images" @click="buttonClick">
                    <img :src="banner.image" :alt="banner.title" class="bannerSale__img" loading="lazy" />
                </a>
                <div class="bannerSale__bottom">
                    <div>
                        <span class="bannerSale__title">{{ banner.title }}</span>
                        <p class="bannerSale__text">{{ banner.description }}</p>
                    </div>
                    <div class="bannerSale__col2">
                        <a :href="banner.url" class="btn btn-primary bannerSale__btn" @click="buttonClick">{{ banner.cta }}</a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        saleBanners: {
            type: Array,
            required: true,
        },
    },
    methods: {
        buttonClick() {
            this.$emit('click-button')
        },

        useMatomoViewportTrack(htmlEl, options) {
            if (!htmlEl || !options) {
                return
            }

            if (!window._paq) {
                return
            }

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(({ isIntersecting }) => {
                    if (isIntersecting) {
                        setTimeout(() => {
                            window._paq.push(['trackEvent', options.category, options.action, options.name, options.value])
                        }, 0)
                        observer.disconnect()
                    }
                })
            })

            observer.observe(htmlEl)
        },

        useMatomoClickTrack(htmlEl, options) {
            if (!htmlEl || !options) {
                return
            }

            if (!window._paq) {
                return
            }

            htmlEl.addEventListener('click', () => {
                setTimeout(() => {
                    window._paq.push(['trackEvent', options.category, options.action, options.name, options.value])
                }, 0)
            })
        }
    },

    mounted() {
        this.$refs.banners.forEach((item) => {
            this.useMatomoViewportTrack(item, {
                category: 'Menu banner - Akce a slevy',
                action: 'view',
                name: item.dataset.title,
                value: +item.dataset.id
            })

            this.useMatomoClickTrack(item, {
                category: 'Menu banner - Akce a slevy',
                action: 'click',
                name: item.dataset.title,
                value: +item.dataset.id
            })
        })
    },
}
</script>

<style lang="scss" scoped>
.bannerSale {
    display: flex;
    padding: 0 30px;
    gap: 20px;
}

.bannerSale__item {
    box-shadow: 0 0 19px -8px rgba(0, 0, 0, 0.33);
    border-radius: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    width: 100%;
    max-width: 33%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 980px) {
        max-width: 50%;
    }

    &:nth-child(3) {
        @media (max-width: 980px) {
            display: none;
        }
    }
}

.bannerSale__img {
    aspect-ratio: 16 / 9;
}

.bannerSale__bottom {
    padding: 18px 12px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    background-color: #FFFFFF;
    flex-direction: row;
}

.bannerSale__title {
    display: block;
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    margin: 0 0 11px 0;
}

.bannerSale__text {
    font-size: 14px;
    line-height: 19px;
    margin: 11px 0 0 0;
}

.bannerSale__col2 {
    display: flex;
    align-items: center;
}

.bannerSale__btn {
    padding: 4px 20px;
    min-width: 135px;
}
</style>
